import { useSEO } from "@/lib/seo";
import PageHeader from "@/components/sections/PageHeader";
import PatientJourney from "@/components/sections/PatientJourney";
import WhyChoose from "@/components/sections/WhyChoose";
import FinalCTA from "@/components/sections/FinalCTA";
import { APPROACH_PILLARS } from "@/lib/site";
import * as Icons from "lucide-react";

export default function ApproachPage() {
  useSEO({
    title: "Approach to Care · Patient-Specific Cancer Treatment",
    description:
      "Evidence-based, multidisciplinary, and compassionate approach to radiation oncology care in Hyderabad.",
    keywords:
      "Patient-Specific Cancer Care Hyderabad, Evidence-based Radiation Oncology, Multidisciplinary Cancer Care",
    path: "/approach",
  });

  return (
    <div data-testid="approach-page">
      <PageHeader
        eyebrow="Approach to Care"
        title="A patient-specific approach to cancer treatment."
        description="Cancer treatments are multidisciplinary and require the latest evidence-based approach. Dr. Anusha believes in customizing treatment options based on each patient's specific condition."
      />

      <section className="py-20 md:py-24">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {APPROACH_PILLARS.map((p, i) => {
              const Icon = Icons[p.icon] || Icons.BookOpen;
              return (
                <div
                  key={p.title}
                  data-testid={`approach-pillar-${i}`}
                  className="rounded-2xl bg-white border border-slate-100 p-8 hover:shadow-[0_20px_40px_-25px_rgba(30,58,138,0.3)] transition-all"
                >
                  <div className="h-12 w-12 rounded-xl bg-blue-50 text-blue-800 flex items-center justify-center">
                    <Icon className="h-6 w-6" strokeWidth={1.7} />
                  </div>
                  <h3 className="mt-5 font-serif text-2xl text-slate-900">
                    {p.title}
                  </h3>
                  <p className="mt-3 text-slate-600 leading-relaxed">
                    {p.body}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      <PatientJourney />
      <WhyChoose />
      <FinalCTA />
    </div>
  );
}
